import { render, staticRenderFns } from "./InvoicePayments.vue?vue&type=template&id=4eadec3b&scoped=true"
import script from "./InvoicePayments.vue?vue&type=script&lang=js"
export * from "./InvoicePayments.vue?vue&type=script&lang=js"
import style0 from "./InvoicePayments.vue?vue&type=style&index=0&id=4eadec3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eadec3b",
  null
  
)

export default component.exports